export default __webpack_public_path__ + "static/media/topproducer.b58475cf.png";